import React, { FunctionComponent } from 'react'
import ReactSwitch from 'react-switch'

import { ISwitchComponent } from './Switch-types'
import { defaultThemeStyles } from './Switch-theme'
import { getThemeStyleValue } from '../../theme/colors'
import { convertColor } from 'core/utils'

const getPropsByType = (type: string | undefined) => {
    switch (type) {
        default:
            return {
                onColor: convertColor(getThemeStyleValue('ui', 'switch', 'on') || defaultThemeStyles.on, {
                    format: 'hex',
                }),
                offColor: convertColor(getThemeStyleValue('ui', 'switch', 'off') || defaultThemeStyles.off, {
                    format: 'hex',
                }),
                onHandleColor: convertColor(
                    getThemeStyleValue('ui', 'switch', 'onHandler') || defaultThemeStyles.onHandler,
                    { format: 'hex' }
                ),
                offHandleColor: convertColor(
                    getThemeStyleValue('ui', 'switch', 'offHandler') || defaultThemeStyles.offHandler,
                    { format: 'hex' }
                ),
                handleDiameter: 18,
                uncheckedIcon: false,
                checkedIcon: false,
                disabled: false,
                boxShadow: 'none',
                activeBoxShadow: 'none',
                height: 16,
                width: 30,
                className: '',
            }
    }
}

export const Switch: FunctionComponent<ISwitchComponent> = ({ type, ...props }) => {
    const switchProps = {
        ...getPropsByType(type),
        ...props,
    }

    return <ReactSwitch {...switchProps} type="checkbox" />
}
